























































import Vue from "vue";
import _ from "lodash";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";
import Api from "@/api/Api";
export default Vue.extend({
  mixins: [AppFormLogicMixin],
  computed: {
    rawPostData() {
      return (this as any).updatePassword;
    },
    validateMethod() {
      return "patch";
    },
    validateUrl() {
      return (
        "/api/adv/user_logins/" +
        Api.singleton().jwtToken.currentTokenObject?.user_login_id +
        "/update_password/validate"
      );
    },
    execMethod() {
      return "patch";
    },
    execUrl() {
      return (
        "/api/adv/user_logins/" +
        Api.singleton().jwtToken.currentTokenObject?.user_login_id +
        "/update_password"
      );
    }
  },
  methods: {
    onComplete() {
      this.$router.push({
        name: "AdvertiserPasswordComplete"
      });
    }
  },
  data() {
    return {
      updatePassword: {
        oldPassword: "",
        newPassword: ""
      },
      isLoading: false,
      phase: "input",
      targetAdvertisementId: this.$route.query.advertisement
    };
  }
});
